import { Button, Paper, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { memo, ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { useStoreActions, useStoreState } from '~/store/hooks';
import { ReactComponent as AiMagicPen } from '~/ui/assets/images/aiAssist/magicpen.svg';
import Textarea from '~/ui/components/inputs/Textarea';
import { ILoadingProps } from '../../types';

import styles from '../../AiAssist.module.scss';

const AddNote = ({ setLoading, loading }: ILoadingProps): ReactElement => {
  const { onGetAIAssist } = useStoreActions(actions => actions.aiAssist);
  const { current } = useStoreState(state => state.user);

  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const note = watch('note');

  const handleClear = () => {
    setValue('note', '');
    setValue('originalNote', '');
    setValue('assistedNote', '');
  };

  const getNotAssist = async () => {
    setValue('originalNote', note);

    setLoading(true);

    await onGetAIAssist({
      clinicId: current.clinic.id,
      data: { note, date: format(new Date(), 'yyyy-MM-dd') },
    });

    setLoading(false);
  };

  return (
    <Paper className={styles.paper}>
      <Typography variant="h6" className={styles.title}>
        Add Note
      </Typography>

      <Textarea register={register} errors={errors} name="note" label="Add Note" rows={18} />

      <div className={styles.actions}>
        <Button
          variant="contained"
          color="primary"
          disabled={!note || loading}
          endIcon={<AiMagicPen />}
          onClick={getNotAssist}
        >
          Assist
        </Button>
        <Button
          variant="outlined"
          color="primary"
          disabled={!note || loading}
          onClick={handleClear}
        >
          Clear
        </Button>
      </div>
    </Paper>
  );
};

export default memo(AddNote);
